<script>
import { SearchInput } from '@/components/page/search-input'

export default {
  props: {
    q: {
      type: String,
      default: ''
    },

    type: {
      type: String,
      default: ''
    }
  },

  methods: {
    submit() {
      this.$emit('submit')
    }
  },

  render() {
    // const types = [
    //   { label: 'ทองรูปพรรณ', value: 'ornament' },
    //   { label: 'ทองแท่ง', value: 'ingot' }
    // ]

    return (
      <el-card>
        <h1 style={{ fontSize: '1.125rem', margin: '0 0 1rem' }}>ค้นหา</h1>
        <el-row type="flex" gutter={32} style={{ flexWrap: 'wrap' }}>
          <el-col sm={24}>
            <SearchInput
              placeholder="ชื่อผลิตภัณฑ์"
              value={this.q}
              onInput={value => {
                this.$emit('update:q', value)
              }}
              onSubmit={this.submit}
            />
          </el-col>
          {/*<el-col
            sm={8}
            style={{
              marginTop: ['sm'].includes(this.$mq) ? '0.5rem' : undefined
            }}
          >
            <el-select
              value={this.type}
              clearable
              placeholder="ประเภททอง"
              class={this.$style.typeSelect}
              onChange={async value => {
                await this.$emit('update:type', value)
                this.submit()
              }}
            >
              {types.map(type => (
                <el-option label={type.label} value={type.value} />
              ))}
            </el-select>
          </el-col>*/}
        </el-row>
      </el-card>
    )
  }
}
</script>

<style lang="scss" module>
.typeSelect {
  height: 100%;
  width: 100%;

  :global(.el-input) {
    height: 100%;
  }

  :global(.el-input__inner) {
    min-height: 100%;
  }
}
</style>
